export const DEFAULT_OUTLOOK_THEME_COLOR = '#0078D4';
export const DEFAULT_TEAMS_PURPLE_THEME_COLOR = '#5B5FC7';
